/**
 * Gestione Mense Backend Authentication API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { GenitoreInfo } from './genitoreInfo';
import { ScuolaInfo } from './scuolaInfo';

export interface StudenteInfo { 
    scuola?: ScuolaInfo;
    genitore?: GenitoreInfo;
    nome?: string;
    cognome?: string;
    codiceFiscale?: string;
    id?: string;
}